import React, { useEffect, useState } from "react";
import config from "../../app/config";

function MyComponent() {
  const [templateContent, setTemplateContent] = useState("");

  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        console.log(config.HTML_URL,"config.HTML_URL")
        const response = await fetch(config.HTML_URL); // Adjust the URL as needed
        const htmlContent = await response.text();
        setTemplateContent(htmlContent);
      } catch (error) {
        console.error("Error fetching template:", error);
      }
    };

    fetchTemplate();
  }, []);

  return <div dangerouslySetInnerHTML={{ __html: templateContent }} />;
}

export default MyComponent;
